/**
 * Breakpoints pour la gestion du responsive dans les Swiper
 * @type {{"1024": {slidesPerView: number, spaceBetween: number}, "768": {slidesPerView: number, spaceBetween: number}, "1280": {slidesPerView: number, spaceBetween: number}}}
 */
const Breakpoints = {
    // when window width is >= 768px
    768: {
        slidesPerView: 3,
        spaceBetween: 30
    },
    // when window width is >= 1024px
    1024: {
        slidesPerView: 4,
        spaceBetween: 30
    },
    // when window width is >= 1280px
    1280: {
        slidesPerView: 6,
        spaceBetween: 30
    }
}

export { Breakpoints }
